let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jh74O")).then(() => parcelRequire('5kpn9'));